
<template>
	<div :id="`blackbaud-donation-form_${guid}`"></div>
</template>

<script>
let bbScriptPromise

function loadBBDonorScript() {
	if (bbScriptPromise) return bbScriptPromise;
	bbScriptPromise = new Promise((resolve, reject) => {
		const existing = document.querySelector('script[src*="donor-form-loader/2/main.js"]');
		if (existing) {
			existing.addEventListener('load', () => resolve());
			if (window.BBDonorFormLoader) resolve();
			return;
		}
		const s = document.createElement("script");
		s.src = "https://sky.blackbaudcdn.net/static/donor-form-loader/2/main.js";
		s.async = true;
		s.onload = () => resolve();
		s.onerror = reject;
		document.body.appendChild(s);
	});
	return bbScriptPromise;
}

export default {
	name: "DonationForm",
	props: {
		env: { type: String, default: "renxt" },
		publicKey: { type: String, required: true },
		guid: { type: String, required: true },
		currency: { type: String, default: "eur" }
	},
	async mounted() {

		await loadBBDonorScript();
		await this.$nextTick();
		requestAnimationFrame(() => {
			if (window.BBDonorFormLoader) {
				window.BBDonorFormLoader.newBlackbaudDonationFormZoned(
					this.env,
					this.publicKey,
					this.guid,
					this.currency
				);
			}
		});
	}
};
</script>